import { render, staticRenderFns } from "./UcWorksheetMiniCard.yaml?vue&type=template&id=2a04fdbb&component"
import script from "./UcWorksheetMiniCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcWorksheetMiniCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports